export default "__VITE_PUBLIC_ASSET__d7ddea7b__"